import { useMsal } from "@azure/msal-react"
import { Box, Button, Container, Paper, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { Link as RouterLink, useSearchParams } from "react-router-dom"
import { loginRequest } from "../authConfig" // Adjust path as needed

const AccessDeniedPage = () => {
  const { instance } = useMsal()
  const [searchParams] = useSearchParams()
  const [reason, setReason] = useState(
    "Access to this application is restricted."
  )

  useEffect(() => {
    const reasonParam = searchParams.get("reason")
    console.log(
      "[AccessDeniedPage] Loaded. Reason from URL param:",
      reasonParam
    )
    if (reasonParam === "auth_failed") {
      setReason(
        "The Microsoft account you are signed in with is not authorized for this application. " +
          "This might be because it belongs to a different organization or is a personal account."
      )
    } else if (reasonParam === "session_issue") {
      setReason(
        "There was an issue verifying your session, or your session may have expired. " +
          "This could be due to browser settings or an inactive session."
      )
    }
    console.log("[AccessDeniedPage] Displaying reason:", reason)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  const handleLogin = () => {
    console.log(
      "[AccessDeniedPage] handleLogin called. Initiating loginRedirect."
    )
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error("[AccessDeniedPage] loginRedirect error:", e)
    })
  }

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" textAlign="center" sx={{ mb: 2 }}>
          {reason}
        </Typography>
        <Typography variant="body2" textAlign="center" sx={{ mb: 3 }}>
          Please ensure you are using your authorized company credentials. You
          may need to fully sign out of your current Microsoft session in your
          browser and then try logging in again.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            fullWidth
          >
            Login with Company Account
          </Button>
          <Button variant="outlined" component={RouterLink} to="/" fullWidth>
            Go to Homepage
          </Button>
        </Box>
      </Paper>
    </Container>
  )
}

export default AccessDeniedPage
